/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_Cooling_HelpInputs */



/**
* | output |
* | --- |
* | "Use of cool outside air in summer to cool premises without cold production, activated automatically according to the conditions below" |
*
* @param {Free_Cooling_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const free_cooling_help = /** @type {((inputs?: Free_Cooling_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Cooling_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Use of cool outside air in summer to cool premises without cold production, activated automatically according to the conditions below")
	return /** @type {LocalizedString} */ ("Utilisation de l’air extérieur frais en été pour refroidir les locaux sans recours à la production de froid, activé automatiquement selon les conditions ci-dessous")
});